import React from 'react';
import StaticInfoPage from 'components/StaticInfoPage';
var faq = [
    {
        id: 'faq-1',
        question: 'Koster det noe å registrere seg eller legge ut annonser på iBok?',
        answer: React.createElement(React.Fragment, null, "Nei, b\u00E5de registrering og bruk av iBok er gratis!"),
    },
    {
        id: 'faq-2',
        question: 'Må jeg registrere meg for å selge eller kjøpe bøker?',
        answer: React.createElement(React.Fragment, null,
            "Ja, men registreringsprosessen er rask og smertefri. Det tar vanligvis under",
            ' ',
            React.createElement("em", null, "30 sekunder"),
            " \u00E5 registrere en ny bruker.",
            React.createElement("p", null, "Kontakt mellom kj\u00F8per og selger skjer via chat som krever at begge parter er registrert p\u00E5 iBok. Dette gir begge parter en god oversikt over hvem de er og har v\u00E6rt i kontakt med tidligere. Som kj\u00F8per kan du ogs\u00E5 lage personlige lister over b\u00F8ker du trenger.")),
    },
    {
        id: 'faq-3',
        question: 'Hvordan registrerer jeg meg som bruker?',
        answer: React.createElement(React.Fragment, null,
            "Klikk ",
            React.createElement("a", { href: "/registrer" }, "Registrer"),
            " i menyen, og fyll inn n\u00F8dvendig informasjon.",
            React.createElement("blockquote", null,
                "Det er n\u00E5 ogs\u00E5 mulig \u00E5 registrere seg ved hjelp av eksterne tjenester som",
                ' ',
                React.createElement("em", null, "Facebook"),
                ", ",
                React.createElement("em", null, "Google"),
                " eller din ",
                React.createElement("em", null, "utdanningsbruker (Feide)"),
                ". Dette betyr at du ikke trenger \u00E5 m\u00E5tte opprette eget passord for iBok, da de eksterne tjenestene tar h\u00E5nd om innlogging.")),
    },
    {
        id: 'faq-4',
        question: 'Kommer jeg til å få masse spam hvis jeg registrerer meg med e-postadressen min på iBok?',
        answer: React.createElement(React.Fragment, null, "iBok kommer ikke til \u00E5 videreformidle e-postadressen din, og vi kommer heller ikke til \u00E5 sende deg u\u00F8nsket epost."),
    },
    {
        id: 'faq-5',
        question: 'Hvordan betaler jeg for bøker?',
        answer: React.createElement(React.Fragment, null,
            "Betalingsm\u00E5ten avtales mellom ",
            React.createElement("em", null, "deg og selgeren"),
            ".",
            React.createElement("ol", null,
                React.createElement("li", null, "F\u00F8rst kontakter du selgere via iBok."),
                React.createElement("li", null, "N\u00E5r selgeren svarer, avtaler dere om boka skal sendes i posten eller om dere kan m\u00F8tes.")),
            React.createElement("blockquote", null, "Flere foretrekker \u00E5 bruke Vipps eller nettbank, fremfor kontanter til betaling. Om dere m\u00F8tes person til person, anbefaler vi \u00E5 ikke betale for boka f\u00F8r du har mottatt den. M\u00E5 boka sendes via posten, b\u00F8r dere bruke postoppkrav for \u00E5 redusere risikoen for svindel."),
            React.createElement("p", null, "iBok har ingen kontroll over betaling mellom kj\u00F8per og selger.")),
    },
    {
        id: 'faq-6',
        question: 'Må jeg reise langt for å hente bestillingene mine?',
        answer: React.createElement(React.Fragment, null, "Nei, iBok baserer seg p\u00E5 at salg skjer i lokalmilj\u00F8et. V\u00E5rt m\u00E5l er at du skal kunne m\u00F8te din kj\u00F8per/selger i din egen by. Fortell dine venner om iBok, slik at vi kan n\u00E5 v\u00E5rt m\u00E5l!"),
    },
    {
        id: 'faq-7',
        question: 'Hvem står bak iBok?',
        answer: React.createElement(React.Fragment, null,
            "iBok drives av",
            ' ',
            React.createElement("a", { href: "http://www.studentmediene.no/", target: "_blank", rel: "noreferrer" }, "Studentmediene i Trondheim AS"),
            ".",
            ' ',
            "For \u00F8vrig informasjon, se ",
            React.createElement("a", { href: "/om" }, "Om iBok"),
            "."),
    },
    {
        id: 'faq-8',
        question: React.createElement(React.Fragment, null,
            "Hvilke rettigheter har jeg dersom ",
            React.createElement("em", null, "kj\u00F8peren/selgeren"),
            " ikke holder sin del av kj\u00F8psavtalen?"),
        answer: React.createElement(React.Fragment, null,
            "For kj\u00F8p og salg mellom privatpersoner er det kj\u00F8psloven som gjelder. Dersom du \u00F8nsker \u00E5 vite mer om dine rettigheter som kj\u00F8per/selger anbefaler vi at du leser det forbrukerr\u00E5det skriver om kj\u00F8psloven",
            ' ',
            React.createElement("a", { href: "http://www.lovdata.no/all/nl-20020621-034.html", target: "_blank", rel: "noreferrer" }, "her"),
            ".",
            React.createElement("p", null,
                "Kj\u00F8psloven i sin helhet finner du p\u00E5 lovdata.no, mer presist",
                ' ',
                React.createElement("a", { href: "http://www.lovdata.no/all/hl-19880513-027.html", target: "_blank", rel: "noreferrer" }, "her"),
                ".",
                ' ',
                "Dersom kj\u00F8per/selger ikke oppfyller sin del av avtalen kan vi bare anbefale at du tar kontakt med den andre parten, og at dere fors\u00F8ker \u00E5 finne en rimelig l\u00F8sning. Du kan godt si i fra til oss om hendelsen, men vi har dessverre ikke ressurser til \u00E5 involvere oss aktivt i slike saker.")),
    },
    {
        id: 'faq-9',
        question: 'Hvordan kan jeg slette annonsene mine når jeg har solgt bøkene mine?',
        answer: React.createElement(React.Fragment, null,
            "Dersom du har solgt boken anbefaler vi at du markerer boken som solgt, fremfor \u00E5 slette den. Du kan gj\u00F8re begge delene ved \u00E5 ",
            React.createElement("a", { href: "/logg_inn" }, "logge inn"),
            " og g\u00E5 til",
            ' ',
            React.createElement("a", { href: "/mine_annonser" }, "Mine annonser"),
            ". Her finner du en liste over alle dine aktive annonser. Du sletter boken ved \u00E5 trykke \"Slett\" eller kan markere den som solgt ved \u00E5 trykke \"Endre\" og sette status til \"Solgt\"."),
    },
    {
        id: 'faq-10',
        question: 'Hvordan kan jeg deaktivere varslinger jeg mottar på e-post angående bøker?',
        answer: React.createElement(React.Fragment, null,
            React.createElement("p", null,
                React.createElement("a", { href: "/logg_inn" }, "Logg inn"),
                " og g\u00E5 til ",
                React.createElement("a", { href: "/bokvarslinger" }, "Bokvarslinger"),
                ". Her kan du trykke \"Slett varsling\" for \u00E5 fjerne framtidige varsler for den boka."),
            React.createElement("p", null, "Tips! Du kan ogs\u00E5 enkelt deaktivere varselet til en bok rett fra e-posten. Dette gj\u00F8r du ved \u00E5 trykke p\u00E5 \"Deaktiver bokvarsling\" fra bunnen av meldingen.")),
    },
    {
        id: 'faq-11',
        question: 'Jeg får ikke til å logge inn',
        answer: React.createElement(React.Fragment, null,
            "Hvis du ikke f\u00E5r til \u00E5 logge inn, kan det hende at du ikke har aktivert kontoen din etter registrering, eller at du har skrevet inn feil passord. Klikk p\u00E5 \"Glemt passord?\" p\u00E5 ",
            React.createElement("a", { href: "/logg_inn" }, "\"Logg inn\"-sida"),
            " for \u00E5 lage et nytt passord."),
    },
    {
        id: 'faq-12',
        question: 'Siden er treg',
        answer: React.createElement(React.Fragment, null, "Rundt starten av hvert semester er det mye trafikk p\u00E5 iBok. Dette gj\u00F8r at serveren v\u00E5r kan f\u00E5 veldig mye \u00E5 gj\u00F8re, og da kan siden bli treg. Vi jobber med \u00E5 optimalisere iBok slik at siden blir raskere."),
    },
    {
        id: 'faq-13',
        question: 'Kan jeg legge ut kompendier?',
        answer: React.createElement(React.Fragment, null,
            "For tiden kan man dessverre kun legge ut annonser for b\u00F8ker som har ISBN-kode",
            ' ',
            React.createElement("em", null, "(tallet som st\u00E5r over/under strekkoden p\u00E5 baksida av boka)"),
            ". Vi har valgt \u00E5 ikke tillate kompendie-annonser p\u00E5 iBok fordi ",
            React.createElement("strong", null, "Kopinor"),
            " sine regler forbyr videresalg av artikkelsamlinger/kompendier. Hvis du er interessert i \u00E5 lese mer, kan du lese denne artikkelen:",
            ' ',
            React.createElement("a", { href: "http://dusken.no/artikkel/23049/ulovlig-videresalg/", target: "_blank", rel: "noreferrer" }, "http://dusken.no/artikkel/23049/ulovlig-videresalg/")),
    },
    {
        id: 'faq-14',
        question: 'Jeg klikker på "Glemt passord", men får ikke epost',
        answer: React.createElement(React.Fragment, null,
            "Hvis det har g\u00E5tt mer enn ti minutter, og du ikke har f\u00E5tt e-post, b\u00F8r du se om den ligger i s\u00F8ppelinnboksen. Hvis du bruker f.eks Hotmail/Outlook, vil du i s\u00E5 fall kunne finne eposten i \"S\u00F8ppelpost\"-mappen. Hvis e-posten ikke er der heller, kan du dobbeltsjekke at du skrev inn riktig e-postadresse og eventuelt pr\u00F8ve p\u00E5 nytt. Hvis du fortsatt ikke f\u00E5r e-post, kan det hende at e-postsystemet til iBok er nede. Ta gjerne",
            ' ',
            React.createElement("a", { href: "#", className: "contact-us" }, "kontakt med oss"),
            ", i s\u00E5 fall."),
    },
    {
        id: 'faq-15',
        question: 'Jeg har blitt svindlet!',
        answer: React.createElement(React.Fragment, null,
            "Se ",
            React.createElement("a", { href: "/hjelp/#faq-8" }, "punkt 8 (Hvilke rettigheter har jeg dersom kj\u00F8peren/selgeren ikke holder sin del av kj\u00F8psavtalen?)"),
            ".",
            ' ',
            "For \u00E5 unng\u00E5 \u00E5 bli svindlet, anbefaler vi at du ikke betaler f\u00F8r du har sjekket at bokas stand er som avtalt og at det er riktig bok."),
    },
    {
        id: 'faq-16',
        question: 'Hvordan kan jeg kontakte de som står bak iBok?',
        answer: React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Du kan kontakte oss i ",
                React.createElement("a", { href: "#", className: "contact-us" }, "kontaktskjemaet"),
                " p\u00E5 bunnen av nettsida."),
            React.createElement("p", null,
                "Har du problemer med \u00E5 f\u00E5 kontakt med oss gjennom skjemaet, kan du ogs\u00E5 sende oss en melding p\u00E5 ",
                React.createElement("a", { href: "https://www.facebook.com/ibok.no", target: "_blank", rel: "noreferrer" }, "facebooksiden v\u00E5r"),
                ".")),
    },
    {
        id: 'faq-17',
        question: 'Jeg får ikke til å publisere en annonse for boka mi',
        answer: React.createElement(React.Fragment, null,
            React.createElement("p", null, "Det kan hende at vi ikke har boka i databasen v\u00E5r. Vi pr\u00F8ver \u00E5 importere de fleste b\u00F8kene automatisk, men dette g\u00E5r ikke alltid. Ta kontakt med oss, s\u00E5 legger vi til boka i databasen v\u00E5r manuelt. N\u00E5r du sender meldinga til oss, pr\u00F8v \u00E5 inkludere mest mulig av f\u00F8lgende info om boka:"),
            React.createElement("ul", null,
                React.createElement("li", null, "ISBN (13 siffer, st\u00E5r ved strekkoden p\u00E5 baksida av boka)"),
                React.createElement("li", null, "Tittel"),
                React.createElement("li", null, "Forfatter(e)"),
                React.createElement("li", null, "Utgiver"),
                React.createElement("li", null, "Utgivelses\u00E5r"),
                React.createElement("li", null, "Utgave"),
                React.createElement("li", null, "Bokbilde"))),
    },
    {
        id: 'faq-18',
        question: 'Hvordan sletter jeg brukeren min?',
        answer: React.createElement(React.Fragment, null,
            "Logg inn og g\u00E5 til ",
            React.createElement("a", { href: "/innstillinger" }, "Innstillinger"),
            ". Klikk deretter p\u00E5 knappen \"Slett brukerkonto\"."),
    },
    {
        id: 'faq-19',
        question: 'Hvor lang tid bruker selgere på å svare?',
        answer: React.createElement(React.Fragment, null, "Det kommer an p\u00E5 selgeren. Selgerne er vanlige folk, typisk studenter. Noen svarer innen en time, mens andre svarer innen to dager. Noen svarer ikke i det hele tatt, beklageligvis. Vi jobber med l\u00F8sninger som vil gj\u00F8re at en st\u00F8rre andel av henvendelsene blir besvart."),
    },
    {
        id: 'faq-20',
        question: 'Sikker betaling av bøker som sendes med posten?',
        answer: React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Vil du v\u00E6re p\u00E5 den sikre sida, kan du sende med",
                ' ',
                React.createElement("a", { href: "http://www.posten.no/produkter-og-tjenester/brev-og-frimerker/postoppkrav-brev", target: "_blank", rel: "noreferrer" }, "Postoppkrav"),
                ".",
                ' ',
                "Da f\u00E5r kj\u00F8peren sendingen utlevert mot betaling til posten. Posten overf\u00F8rer da betalingen til selgerens konto. En sending med oppkrav koster mer enn en vanlig sending. Man kan alts\u00E5 spare penger ved \u00E5 sende uten oppkrav."),
            React.createElement("blockquote", null, "Er du en kj\u00F8per, og selgeren krever forh\u00E5ndsbetaling, b\u00F8r du v\u00E6re obs. Husk at ikke alle har \u00E6rlige hensikter, og at svindel kan forekomme. Sjekk derfor at selgeren er seri\u00F8s og at annonsen er reell.")),
    },
    {
        id: 'faq-21',
        question: 'Jeg har lagt ut annonser. Hvordan får jeg beskjed når kjøpere melder sin interesse?',
        answer: React.createElement(React.Fragment, null, "Du mottar da e-post til e-postadressen som brukeren din er registrert med. Hvis du har en offentlig \"selger\"-side med synlig telefonnummer, kan folk som ser den alternativt kontakte deg direkte ved \u00E5 ringe eller sende SMS."),
    },
    {
        id: 'faq-22',
        question: 'Det ser ut som brukerkontoen min har blitt forvekslet med en annen',
        answer: React.createElement(React.Fragment, null, "Hvis du registrerte deg i kontaktskjemaet (kontakt selger) mellom ca. 7. juli og 24. august 2013, kan den opprettede brukerkontoen din ha blitt rammet av en teknisk feil. Symptomer ville ha v\u00E6rt at du fikk annonser og meldingslogg som ikke stammet fra deg. Dette beklager vi. Feilen ble rettet 24. august 2013. Hvis brukerkontoen din ble rammet, er en mulig l\u00F8sning p\u00E5 problemet \u00E5 slette brukerkontoen din og s\u00E5 lage en ny."),
    },
    {
        id: 'vipps',
        question: 'Hva betyr Vipps?',
        answer: React.createElement(React.Fragment, null, "Vipps-ikonet er en m\u00E5te for selgere \u00E5 symbolisere at de kan ta i mot betaling gjennom vipps."),
    },
    {
        id: 'oauth',
        question: 'Hva betyr Facebook-, Google- og Feide-knappene?',
        answer: React.createElement(React.Fragment, null, "Det er n\u00E5 mulig for deg \u00E5 logge inn p\u00E5 iBok gjennom din Facebook-, Google- eller universitetsbruker. Dette betyr at du slipper \u00E5 m\u00E5tte huske enda et passord, p\u00E5 enda en nettside."),
    },
];
var HelpPage = function () { return (React.createElement(StaticInfoPage, { title: "Hjelp", introduction: React.createElement(React.Fragment, null,
        React.createElement("p", { className: "introduction" }, "Har du sp\u00F8rsm\u00E5l rundt hvordan iBok fungerer, hvordan du bruker tjenesten eller hva du skal gj\u00F8re i tilfelle svindel? P\u00E5 denne sida finner du svar p\u00E5 de vanligste sp\u00F8rsm\u00E5lene vi f\u00E5r om iBok."),
        React.createElement("p", null,
            "Dersom du ikke finner svar p\u00E5 sp\u00F8rsm\u00E5let ditt, kan du",
            ' ',
            React.createElement("a", { href: "#", className: "contact-us blue-color" }, "kontakte oss her"),
            ".")), sectionsId: "answers", sections: faq.map(function (item) { return ({
        id: item.id,
        title: item.question,
        body: item.answer,
    }); }) })); };
export default HelpPage;
